<kodit-list [items]="kontaktList" [listConfig]="listConfig"></kodit-list>
